import api from "./apiClient";

// TAG AVAILABILITY
/**
 * Set availability for a tag in a facility
 * @param facilityId - ID of the facility
 * @param data - Tag availability data
 * @returns Promise with the response
 */
const setTagAvailability = (facilityId: any, data: any) => {
  return api.post(`/api/facilities/${facilityId}/tag-availability`, data);
};

/**
 * Get availability for a specific tag in a facility
 * @param facilityId - ID of the facility
 * @param tagName - Name of the tag
 * @returns Promise with the response
 */
const getTagAvailability = (facilityId: any, tagName: any) => {
  return api.get(`/api/facilities/${facilityId}/tag-availability/${tagName}`);
};

/**
 * Get all tag availabilities for a facility
 * @param facilityId - ID of the facility
 * @returns Promise with the response
 */
const getAllTagAvailabilities = (facilityId: any) => {
  return api.get(`/api/facilities/${facilityId}/tag-availabilities`);
};

/**
 * Delete availability for a specific tag in a facility
 * @param facilityId - ID of the facility
 * @param tagName - Name of the tag
 * @returns Promise with the response
 */
const deleteTagAvailability = (facilityId: any, tagName: any) => {
  return api.delete(`/api/facilities/${facilityId}/tag-availability/${tagName}`);
};

/**
 * Get facility by ID with all tag availabilities
 * @param facilityId - ID of the facility
 * @returns Promise with the response
 */
const getFacilityWithTagAvailabilities = (facilityId: any) => {
  return api.get(`/api/facilities/${facilityId}/with-tag-availabilities`);
};

/**
 * Search for facilities with specific tag availability
 * @param tag - Tag name to search for
 * @param day - Day of the week (monday, tuesday, etc.)
 * @param time - Optional time to check availability (HH:MM format)
 * @returns Promise with the response
 */
const searchFacilitiesByTagAvailability = (tag: any, day: any, time?: any) => {
  const params: any = { tag, day };
  if (time) {
    params.time = time;
  }
  
  return api.get('/api/facilities/search-by-tag-availability', { params });
};

export {
  setTagAvailability,
  getTagAvailability,
  getAllTagAvailabilities,
  deleteTagAvailability,
  getFacilityWithTagAvailabilities,
  searchFacilitiesByTagAvailability
};